'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _reactRouterBootstrap = require('react-router-bootstrap');

var _Navbar = require('react-bootstrap/lib/Navbar');

var _Navbar2 = _interopRequireDefault(_Navbar);

var _Nav = require('react-bootstrap/lib/Nav');

var _Nav2 = _interopRequireDefault(_Nav);

var _NavItem = require('react-bootstrap/lib/NavItem');

var _NavItem2 = _interopRequireDefault(_NavItem);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _auth = require('redux/modules/auth');

var _reactRouterRedux = require('react-router-redux');

var _client_config = require('../../client_config');

var _client_config2 = _interopRequireDefault(_client_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var App = (_dec = (0, _reactRedux.connect)(function (state) {
  return { user: state.auth.user };
}, { logout: _auth.logout, pushState: _reactRouterRedux.push }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(App, _Component);

  function App() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, App);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = App.__proto__ || (0, _getPrototypeOf2.default)(App)).call.apply(_ref, [this].concat(args))), _this), _this.handleLogout = function (event) {
      event.preventDefault();
      _this.props.logout();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(App, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!this.props.user && nextProps.user) {
        // login
        // this.props.pushState('/search');
      } else if (this.props.user && !nextProps.user) {
        // logout
        this.props.pushState('/');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var user = this.props.user;

      var styles = require('./App.scss');

      return _react2.default.createElement(
        'div',
        { className: styles.app },
        _react2.default.createElement(_reactHelmet2.default, _client_config2.default.app.head),
        _react2.default.createElement(
          _Navbar2.default,
          { fixedTop: true, inverse: true },
          _react2.default.createElement(
            _Navbar2.default.Header,
            null,
            _react2.default.createElement(
              _Navbar2.default.Brand,
              null,
              _react2.default.createElement(
                _reactRouter.IndexLink,
                { to: '/', activeStyle: { color: '#33e0ff' } },
                _react2.default.createElement('div', { className: styles.brand })
              )
            ),
            _react2.default.createElement(_Navbar2.default.Toggle, null)
          ),
          _react2.default.createElement(
            _Navbar2.default.Collapse,
            { eventKey: 0 },
            _react2.default.createElement(
              _Nav2.default,
              { navbar: true, pullRight: true },
              user && _react2.default.createElement(
                _reactRouterBootstrap.LinkContainer,
                { to: '/search' },
                _react2.default.createElement(
                  _NavItem2.default,
                  { eventKey: 2 },
                  'Search'
                )
              ),
              _react2.default.createElement(
                _reactRouterBootstrap.LinkContainer,
                { to: '/about' },
                _react2.default.createElement(
                  _NavItem2.default,
                  { eventKey: 4 },
                  'About'
                )
              ),
              user && _react2.default.createElement(
                _reactRouterBootstrap.LinkContainer,
                { to: '/logout' },
                _react2.default.createElement(
                  _NavItem2.default,
                  {
                    eventKey: 6,
                    className: 'logout-link',
                    onClick: this.handleLogout
                  },
                  'Logout'
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.appContent },
          this.props.children
        ),
        _react2.default.createElement('div', { className: styles.background })
      );
    }
  }]);
  return App;
}(_react.Component), _class2.propTypes = {
  children: _react.PropTypes.object.isRequired,
  user: _react.PropTypes.object,
  logout: _react.PropTypes.func.isRequired,
  pushState: _react.PropTypes.func.isRequired
}, _class2.contextTypes = {
  store: _react.PropTypes.object.isRequired
}, _temp2)) || _class);
exports.default = App;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/App/App.js
 ** module id = 1391
 ** module chunks = 0
 **/